import { createSlice } from "@reduxjs/toolkit";
import { getInstagramAdsetList, updateInstagramAdsetStatus } from "./ThunkActions";
import { REDUCER_NAME, iInstagramAdsetState } from "./Types";

// Define initial state based on the provided structure
const initialState: iInstagramAdsetState = {
  isLoading: false,
  instagramAdsetList: [],
  errorMessage: null,
};

export const instagramAdsetSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetinstagramAdsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInstagramAdsetList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInstagramAdsetList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.instagramAdsetList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getInstagramAdsetList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Ads list";
        state.isLoading = false;
      })
       // Update Adset Status
    .addCase(updateInstagramAdsetStatus.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
    .addCase(updateInstagramAdsetStatus.fulfilled, (state) => {
      state.isLoading = false;
      state.errorMessage = null;
    })
    .addCase(updateInstagramAdsetStatus.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload?.message || "Update failed";
    });
},
});

export const { resetinstagramAdsState } = instagramAdsetSlice.actions;
export default instagramAdsetSlice.reducer;
